interface Iprops {
  width: number;
  height: number;
  active: boolean;
}

export const LibraryIcon = ({ width, height, active }: Iprops) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {active && (
        <rect
          width={width}
          height={height}
          rx="4"
          transform="matrix(-1 0 0 1 28 0)"
          fill="#DDEDF4"
        />
      )}
      <path
        d="M6.23 15.75H10.27C12.28 15.75 13.25 14.82 13.25 12.9V6.1C13.25 4.18 12.27 3.25 10.27 3.25H6.23C4.22 3.25 3.25 4.18 3.25 6.1V12.9C3.25 14.82 4.23 15.75 6.23 15.75ZM10.27 4.75C11.54 4.75 11.75 5.09 11.75 6.1V12.9C11.75 13.91 11.54 14.25 10.27 14.25H6.23C4.96 14.25 4.75 13.91 4.75 12.9V6.1C4.75 5.09 4.96 4.75 6.23 4.75H10.27Z"
        fill={active ? "#811797" : "#7B7B7B"}
      />
      <path
        d="M6.23 24.75H10.27C12.28 24.75 13.25 23.82 13.25 21.9V20.1C13.25 18.18 12.27 17.25 10.27 17.25H6.23C4.22 17.25 3.25 18.18 3.25 20.1V21.9C3.25 23.82 4.23 24.75 6.23 24.75ZM10.27 18.75C11.54 18.75 11.75 19.09 11.75 20.1V21.9C11.75 22.91 11.54 23.25 10.27 23.25H6.23C4.96 23.25 4.75 22.91 4.75 21.9V20.1C4.75 19.09 4.96 18.75 6.23 18.75H10.27Z"
        fill={active ? "#811797" : "#7B7B7B"}
      />
      <path
        d="M17.73 24.75H21.77C23.78 24.75 24.75 23.82 24.75 21.9V15.1C24.75 13.18 23.77 12.25 21.77 12.25H17.73C15.72 12.25 14.75 13.18 14.75 15.1V21.9C14.75 23.82 15.73 24.75 17.73 24.75ZM21.77 13.75C23.04 13.75 23.25 14.09 23.25 15.1V21.9C23.25 22.91 23.04 23.25 21.77 23.25H17.73C16.46 23.25 16.25 22.91 16.25 21.9V15.1C16.25 14.09 16.46 13.75 17.73 13.75H21.77Z"
        fill={active ? "#811797" : "#7B7B7B"}
      />
      <path
        d="M17.73 10.75H21.77C23.78 10.75 24.75 9.82 24.75 7.9V6.1C24.75 4.18 23.77 3.25 21.77 3.25H17.73C15.72 3.25 14.75 4.18 14.75 6.1V7.9C14.75 9.82 15.73 10.75 17.73 10.75ZM21.77 4.75C23.04 4.75 23.25 5.09 23.25 6.1V7.9C23.25 8.91 23.04 9.25 21.77 9.25H17.73C16.46 9.25 16.25 8.91 16.25 7.9V6.1C16.25 5.09 16.46 4.75 17.73 4.75H21.77Z"
        fill={active ? "#811797" : "#7B7B7B"}
      />
    </svg>
  );
};
